import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import CommonStructured from "../common-components/CommonStructured";
import {
  fetchExpenseRequestsData,
  fetchProcessManagerData,
} from "../../redux/hygiene-reducers/hygieneSlice";
import ExpenseRequestLists from "./ExpenseRequestLists";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import ExpenseForm from "./ExpenseForm";
import ExpenseApproveRejectForm from "./ExpenseApproveRejectForm";
import CmnFilters from "../lead-management/common/CmnFilters";
import { isManagerRole as checkIsManagerRole } from "../common-data/Conversions";

import { Tab, TabList, Tabs, TabPanel } from "react-tabs";
import PettyCashLists from "./PettyCashLists";
import ClusterManagerPettyCashLists from "./ClusterManagerPettyCashLists";
import ClusterManagerDetails from "./ClusterManagerDetails";
import { useGetFetchNew } from "../../data/Queries";
import {
  cluster_manager_petty_cash,
  expense_stats,
  petty_cash_stats,
} from "../../data/ApiEndpoints";
import DetailsExpenseListing from "./details/DetailExpenseListing";
import CmWallet from "./expense-management/CmWallet";
import ClusterManagerPettyCashListsMobile from "./ClusterManagerPettyCashListsMobile";
import ExpenseAnalyticsLanding from "./expense-analytics/ExpenseAnalyticsLanding";
import moment from "moment";

const ExpenseRequestsLanding = ({ userInfoData, isCustom }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { expenseRequestsLoading, processManagerData } = useSelector(
    (state) => state.hygiene
  );
  const [allExpenseManagers, setAllExpenseManagers] = useState(null);

  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const isGym = userInfoData?.account_type === "gym";
  const isReceptionist =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const isAdmin =
    userInfoData?.account_type === "admin" &&
    allExpenseManagers?.super_process_manager !== 1 &&
    allExpenseManagers?.role_type !== "accountant";

  const isAccountant = allExpenseManagers?.role_type === "accountant";
  const isSuperProcessManager = allExpenseManagers?.super_process_manager === 1;

  const isAdminOrSuperProcessManager = isAdmin || isSuperProcessManager;

  const showAllExpenseManagers =
    isClusterManager || isSuperProcessManager || isAccountant;

  const showAllPettyCashManagers =
    isSuperProcessManager || isAccountant || isAccountant;

  const initialAllExpenseManagers = {
    uid: userInfoData?.uid || userInfoData?.user_id || "",
    user_id: userInfoData?.uid || userInfoData?.user_id || "",
    role_type: "cluster_manager",
    user_name: userInfoData?.name || "",
    user_email: userInfoData?.email || "",
    user_mobile: userInfoData?.mobile || "",
    status: "active",
    date_added: new Date().toISOString().split("T")[0],
    last_updated: new Date().toISOString().split("T")[0],
  };

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // 0 for Expense, 1 for Petty Cash

  // Separate filters for petty cash
  const [pettyCashFilters, setPettyCashFilters] = useState({
    requested_by: isClusterManager ? userInfoData?.uid : "",
    page: 1,
    limit: 10,
  });

  // Separate filters for cluster manager
  const [clusterManagerFilters, setClusterManagerFilters] = useState({
    user_id: isClusterManager ? userInfoData?.uid : "",
    page: 1,
    limit: 10,
  });

  // Get current month's start and end dates using moment
  const currentMonthDates = {
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().endOf("month").format("YYYY-MM-DD"),
  };

  // console.log("allExpenseManagers", allExpenseManagers?.super_process_manager);

  const iniAllFilter = {
    selectedGym: !isAdminOrSuperProcessManager && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value: userInfoData?.gym_id || "",
        }
      : "",
    isActive: "",
    selAddedby: "",
    selectedApprovalManager: "",
    selectedPaidBy: "",
    selectedExpenseCategory: "",
    leadAddDateFrom: currentMonthDates.start,
    leadAddDateTo: currentMonthDates.end,
    expenseApproveRejectDateFrom: "",
    expenseApproveRejectDateTo: "",
    paidDateFrom: "",
    paidDateTo: "",
    searchString: "",
    filterType: "",
  };

  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: activeTabIndex === 1 ? "" : allFilters.selectedGym?.value || "",
    // approval_manager_id: allExpenseManagers ? allExpenseManagers.user_id : "",
    // requested_by:
    //   isClusterManager && activeTabIndex === 1
    //     ? userInfoData?.uid || userInfoData?.user_id || ""
    //     : showAllExpenseManagers && activeTabIndex === 0
    //     ? ""
    //     : userInfoData?.uid || userInfoData?.user_id || "",

    requested_by: allFilters.selAddedby?.value
      ? allFilters.selAddedby?.value
      : activeTabIndex === 0
      ? userInfoData?.super_process_manager == 1 ||
        userInfoData?.role_type === "accountant" ||
        userInfoData?.account_type === "cluster_manager"
        ? ""
        : userInfoData?.uid || userInfoData?.user_id || ""
      : activeTabIndex === 1
      ? showAllPettyCashManagers
        ? ""
        : userInfoData?.uid || userInfoData?.user_id || ""
      : "",
    approval_manager_id: allFilters.selectedApprovalManager?.value || "",
    paid_by: allFilters.selectedPaidBy?.value || "",
    expense_category: allFilters.selectedExpenseCategory?.value || "",
    status: allFilters.isActive?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
    aprv_rej_start_date: allFilters.expenseApproveRejectDateFrom || "",
    aprv_rej_end_date: allFilters.expenseApproveRejectDateTo || "",
    paid_start_date: allFilters.paidDateFrom || "",
    paid_end_date: allFilters.paidDateTo || "",
    is_petty_cash: activeTabIndex === 1 ? 1 : 0,
    expense_type:
      isClusterManager && activeTabIndex === 0
        ? "gym"
        : activeTabIndex === 1
        ? "wtf"
        : "",
    filter_type: allFilters.filterType || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    image: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function handleModalClose() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    const resetFilters = {
      ...iniAllFilter,
      leadAddDateFrom: moment().startOf("month").format("YYYY-MM-DD"),
      leadAddDateTo: moment().endOf("month").format("YYYY-MM-DD"),
    };
    setAllFilters(resetFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({
        ...prevs,
        requested_amount: allFilters.searchString,
      }));
    }
  };

  const handleTabChange = (index) => {
    if (
      typeof index === "number" &&
      (index === 0 || index === 1 || index === 2 || index === 3)
    ) {
      setActiveTabIndex(index);
      setIsPage(0); // Reset to first page when switching tabs
    }
  };

  function getProcessExpenseCategories() {
    const payload = {
      filters: {
        page: 1,
        limit: 1,
        status: "active",
        user_id: userInfoData?.uid || userInfoData?.user_id || "",
      },
      token: userInfoData?.token,
    };
    dispatch(fetchProcessManagerData(payload));
  }

  function getExpenseRequests(filters) {
    dispatch(
      fetchExpenseRequestsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const {
    data: allPettyCashStats,
    isLoading: allPettyCashStatsLoading,
    refetch: refetchPettyCashStats,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "petty_cash_stats",
    url: petty_cash_stats,
    filters: filters,
  });

  const {
    data: allExpenseStats,
    isLoading: allExpenseStatsLoading,
    refetch: refetchExpenseStats,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "expense_stats",
    url: expense_stats,
    filters: {
      ...filters,
      status: "",
    },
  });

  // console.log("allExpenseStats", allExpenseStats);

  console.log("filters", filters);

  const {
    data: clusterManagerData,
    isLoading: clusterManagerDataLoading,
    refetch: refetchClusterManagerData,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "cluster_manager_petty_cash",
    url: cluster_manager_petty_cash,
    filters: clusterManagerFilters,
  });

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  useEffect(() => {
    getProcessExpenseCategories();
  }, []);

  useEffect(() => {
    if (processManagerData?.status && processManagerData?.data?.length > 0) {
      const allCats = processManagerData.data?.[0] || {};

      // console.log("allCats", allCats);

      setAllExpenseManagers(allCats);
    } else {
      setAllExpenseManagers(null);
    }
  }, [processManagerData]);

  // console.log("allFilters", allFilters);
  // console.log("processManagerData", processManagerData);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdminOrSuperProcessManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value: userInfoData?.gym_id || "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  // console.log("allExpenseManagers", allExpenseManagers);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: activeTabIndex === 1 ? "" : allFilters.selectedGym?.value || "",
      requested_by: allFilters.selAddedby?.value
        ? allFilters.selAddedby?.value
        : activeTabIndex === 0
        ? userInfoData?.super_process_manager == 1 ||
          userInfoData?.role_type === "accountant" ||
          userInfoData?.account_type === "cluster_manager"
          ? ""
          : userInfoData?.uid || userInfoData?.user_id || ""
        : activeTabIndex === 1
        ? showAllPettyCashManagers
          ? ""
          : userInfoData?.uid || userInfoData?.user_id || ""
        : "",
      approval_manager_id: allFilters.selectedApprovalManager?.value || "",
      paid_by: allFilters.selectedPaidBy?.value || "",
      expense_category: allFilters.selectedExpenseCategory?.value || "",
      status: allFilters.isActive?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
      aprv_rej_start_date: allFilters.expenseApproveRejectDateFrom || "",
      aprv_rej_end_date: allFilters.expenseApproveRejectDateTo || "",
      paid_start_date: allFilters.paidDateFrom || "",
      paid_end_date: allFilters.paidDateTo || "",
      is_petty_cash: activeTabIndex === 1 ? 1 : 0,
      expense_type:
        isClusterManager && activeTabIndex === 0
          ? "gym"
          : activeTabIndex === 1
          ? "wtf"
          : "",
      filter_type: allFilters.filterType || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.selectedApprovalManager,
    allFilters.selectedPaidBy,
    allFilters.isActive,
    allFilters.selectedExpenseCategory,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.expenseApproveRejectDateFrom,
    allFilters.expenseApproveRejectDateTo,
    allFilters.paidDateFrom,
    allFilters.paidDateTo,
    activeTabIndex,
    showAllExpenseManagers,
    showAllPettyCashManagers,
    allFilters.filterType,
  ]);

  // console.log("filters", filters);

  useEffect(() => {
    getExpenseRequests(filters);
    refetchPettyCashStats();
    refetchClusterManagerData();
    refetchExpenseStats();
  }, [filters]);

  // Update petty cash filters when page or pageLimit changes
  useEffect(() => {
    setPettyCashFilters((prev) => ({
      ...prev,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  // Update cluster manager filters when page changes
  useEffect(() => {
    setClusterManagerFilters((prev) => ({
      ...prev,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, requested_amount: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const onReload = () => {
    getExpenseRequests(filters);
    refetchPettyCashStats();
    refetchClusterManagerData();
    refetchExpenseStats();
  };

  const handleCardClick = (status) => {
    setIsPage(0); // Reset to first page when filtering by status

    // Check if the same card is clicked again - if so, reset the filter
    if (allFilters.isActive?.value === status) {
      setAllFilters((prevs) => ({
        ...prevs,
        isActive: "",
      }));
      return;
    }

    // Find the status option for the filter
    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Approved & Paid", value: "approved_paid" },
      { label: "Approved & Not Paid", value: "approved_notpaid" },
      { label: "Rejected", value: "rejected" },
      { label: "Rejected By Accountant", value: "rejected_by_acc" },
    ];

    const selectedStatusOption = statusOptions.find(
      (option) => option?.value === status
    );

    if (selectedStatusOption) {
      setAllFilters((prevs) => ({
        ...prevs,
        isActive: selectedStatusOption,
      }));
    }
  };

  const onPettyCashCardClick = (fieldName) => {
    setIsPage(0); // Reset to first page when filtering by status

    // Check if the same card is clicked again - if so, reset the filter
    if (allFilters.filterType === fieldName) {
      setAllFilters((prevs) => ({
        ...prevs,
        filterType: "",
      }));
      return;
    }

    // Set the selected filter type
    setAllFilters((prevs) => ({
      ...prevs,
      filterType: fieldName,
    }));
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selAddedby: "",
    }));
  }, [activeTabIndex]);

  return (
    <>
      <style jsx>{`
        /* Wallet Section Responsive */
        .expense-wallet-section {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          min-width: fit-content;
        }

        @media (max-width: 768px) {
          .expense-wallet-section {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            order: -1;
            background: white;
            padding: 16px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            margin-bottom: 16px;
          }
        }

        .expense-tabs-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }

        @media (max-width: 768px) {
          .expense-tabs-container {
            flex-direction: column;
            display: flex;
            gap: 16px;
          }
        }
      `}</style>

      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={handleModalClose}
        contentLabel="View Image Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "add" || modValues.cardName === "edit" ? (
          <ExpenseForm
            userInfoData={userInfoData}
            isEdit={modValues.cardName === "edit"}
            rowData={modValues.rowData}
            closeModal={handleModalClose}
            callFunction={onReload}
          />
        ) : modValues.cardName === "approve" ||
          modValues.cardName === "reject" ||
          modValues.cardName === "pay" ? (
          <ExpenseApproveRejectForm
            userInfoData={userInfoData}
            cardName={modValues.cardName}
            rowData={modValues.rowData}
            closeModal={handleModalClose}
            callFunction={() => getExpenseRequests(filters)}
            isExpenseManager={allExpenseManagers}
          />
        ) : (
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName === "image"
                ? "modal-container-abs"
                : modValues.cardName === "cluster_manager_details"
                ? "mod-width-70p"
                : "mod-width-50p"
            }`}
          >
            <ModalHeadAndClose title=" " onClose={handleModalClose} />

            {modValues.cardName === "image" ? (
              <div className="discussionModalMessage">
                <img src={modValues.image} alt="bill" />
              </div>
            ) : modValues.cardName === "description" ? (
              <div className="discussionModalMessage">
                <p
                  className="message"
                  dangerouslySetInnerHTML={{
                    __html: modValues.description || "No Content Available",
                  }}
                ></p>
              </div>
            ) : modValues.cardName === "view_details" ? (
              <DetailsExpenseListing
                row={modValues.rowData}
                userInfoData={userInfoData}
                isExpenseManager={
                  isClusterManager
                    ? initialAllExpenseManagers
                    : allExpenseManagers
                }
                setModValues={setModValues}
                callFunction={onReload}
              />
            ) : modValues.cardName === "cluster_manager_details" ? (
              <ClusterManagerDetails
                row={modValues.rowData}
                userInfoData={userInfoData}
              />
            ) : null}
          </div>
        )}
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Expense Management"}
            createBtnTxt={
              isAccountant
                ? ""
                : isClusterManager
                ? "+ Add New Petty Cash Request"
                : "+ Add New Expense Request"
            }
            onClickCreateBtn={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "add",
              }))
            }
            isReload={() => {
              getExpenseRequests(filters);
              refetchPettyCashStats();
              refetchClusterManagerData();
            }}
            onClickBackBtn={isCustom ? handleBack : null}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from={"expense-management"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isLoading={expenseRequestsLoading}
            searchPlaceHolder="Search by Expense Amount"
            clickedCard={activeTabIndex}
          />

          <br />
          {isReceptionist || isAdmin ? (
            // For receptionists, show only expense list without tabs
            <div className="tab-content-wrapper">
              <ExpenseRequestLists
                userInfoData={userInfoData}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                setModValues={setModValues}
                isExpenseManager={allExpenseManagers}
                callFunction={() => getExpenseRequests(filters)}
                onCardClick={handleCardClick}
                selectedStatus={allFilters.isActive?.value}
                allExpenseStats={allExpenseStats?.data}
                allExpenseStatsLoading={allExpenseStatsLoading}
              />
            </div>
          ) : (
            // For other users, show tabs with Expense, Petty Cash, and Cluster Manager Petty Cash (for admin/cluster manager only)
            <Tabs
              selectedIndex={
                typeof activeTabIndex === "number" ? activeTabIndex : 0
              }
              onSelect={handleTabChange}
              key="expense-tabs"
            >
              <div className="expense-tabs-container">
                <TabList>
                  <Tab>Expense</Tab>
                  <Tab>Petty Cash</Tab>
                  {(isAdminOrSuperProcessManager ||
                    isClusterManager ||
                    isAccountant) && <Tab>Cluster Manager Allocation</Tab>}
                  <Tab>Analytics</Tab>
                </TabList>

                {isClusterManager && (
                  <div className="expense-wallet-section">
                    <CmWallet
                      userInfoData={userInfoData}
                      clusterManagerData={clusterManagerData}
                    />
                  </div>
                )}
              </div>

              <TabPanel>
                <div className="tab-content-wrapper">
                  <ExpenseRequestLists
                    userInfoData={userInfoData}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    isExpenseManager={allExpenseManagers}
                    callFunction={() => getExpenseRequests(filters)}
                    onCardClick={handleCardClick}
                    selectedStatus={allFilters.isActive?.value}
                    allExpenseStats={allExpenseStats?.data}
                    allExpenseStatsLoading={allExpenseStatsLoading}
                  />
                </div>
              </TabPanel>

              {/* {(isAdminOrSuperProcessManager || isClusterManager) && ( */}
              <TabPanel>
                <div className="tab-content-wrapper">
                  <PettyCashLists
                    userInfoData={userInfoData}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    isExpenseManager={allExpenseManagers}
                    allPettyCashStats={allPettyCashStats}
                    allPettyCashStatsLoading={allPettyCashStatsLoading}
                    refetchPettyCashStats={refetchPettyCashStats}
                    onCardClick={onPettyCashCardClick}
                    selectedStatus={allFilters.filterType}
                  />
                </div>
              </TabPanel>
              {/* )} */}

              {/* {(isAdminOrSuperProcessManager || isClusterManager) && ( */}
              <TabPanel>
                <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30 hideMobile tab-content-wrapper">
                  {/* <div className=""> */}
                  <ClusterManagerPettyCashLists
                    userInfoData={userInfoData}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    clusterManagerData={clusterManagerData}
                    clusterManagerDataLoading={clusterManagerDataLoading}
                  />
                  {/* </div> */}
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <ClusterManagerPettyCashListsMobile
                    userInfoData={userInfoData}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    clusterManagerData={clusterManagerData}
                    clusterManagerDataLoading={clusterManagerDataLoading}
                    setModValues={setModValues}
                  />
                </div>
              </TabPanel>
              {/* )} */}

              <TabPanel>
                <div className="tab-content-wrapper">
                  <ExpenseAnalyticsLanding
                    userInfoData={userInfoData}
                    filters={filters}
                    setFilters={setFilters}
                    // isPage={isPage}
                    // setIsPage={setIsPage}
                    // pageLimit={pageLimit}
                    // setPageLimit={setPageLimit}
                  />
                </div>
              </TabPanel>
            </Tabs>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ExpenseRequestsLanding;

// useEffect(() => {
//   if (allExpenseManagers && !isAccountant && !isAdminOrSuperProcessManager) {
//     setAllFilters((prevs) => ({
//       ...prevs,
//       selectedApprovalManager: {
//         label: allExpenseManagers?.user_name || "",
//         value: allExpenseManagers?.user_id || "",
//       },
//     }));
//   } else if (isAdminOrSuperProcessManager) {
//     // Clear the selectedApprovalManager if super_process_manager is 1
//     setAllFilters((prevs) => ({
//       ...prevs,
//       selectedApprovalManager: "",
//     }));
//   } else if (isAccountant) {
//     setAllFilters((prevs) => ({
//       ...prevs,
//       selectedApprovalManager: "",
//     }));
//   }
// }, [allExpenseManagers, isAccountant, isSuperProcessManager]);
